import { mapGetters } from 'vuex';

export const editableMixin = {
  data() {
    return {};
  },

   computed: {
           ...mapGetters([

             'isPollEditable',

           ]),
          },

  methods: {
    isAnswerEditable(participant) {
      if (this.isClosedPoll) return false;
      if (this.isOwner) return true;
      if (this.isDeadlinePassed) return false;
      return this.isEditable(participant);
    },

    isEditable(participant, poll) {
      if (!participant) return false;

      if (poll && !this.isPollEditable) {
        console.log('Poll is not editable', poll);
        return false;
      }

      //  project admin  has unlimited power
      if (this.isOwner) {
        return true;
      }

      // check if it is curent user
      if (participant.isCurrentUser) return true;

      let userId = participant.user_id;

      //console.log('isEditable:', userId, this.userId);
      if (userId && userId == this.userId) {
        return true;
      }

      // check for private invitation key
      if (
        participant.invitation_id &&
        participant.invitation_id == this.invitationId
      ) {
        return true;
      }

      // iswitch for editable anonymous user
      const editableAnonymousUser = false;
      if (editableAnonymousUser) {
        if (participant.user_id == null) {
          return true;
        }
      }
      return false;
    },
  },
};
